import React, { useEffect, useState } from 'react'
import TabsHomePage from '../components/tabsHomePage/tabsHomePage'
import { useNavigate } from 'react-router-dom'
import { LoadingBar, BufferService } from 'src/M_Components'

export default function HomePage() {
    const navigate = useNavigate()
    const roleService = new BufferService('identity/userrole')
    const [isLoaded, setIsLoaded] = useState(false) // Changed to false for bypass
    const [permissions, setPermissions] = useState([])

    useEffect(() => {
        //* BYPASS - Load fake user data from localStorage
        const fakeUserProfile = localStorage.getItem('userProfile')
        
        if (fakeUserProfile) {
            const userData = JSON.parse(fakeUserProfile)
            
            sessionStorage.setItem('companies', JSON.stringify([{ CompanyId: 1, CompanyName: "Devlop Systems" }]))
            localStorage.setItem("accountName", userData.Name)
            localStorage.setItem("accountCompany", "Devlop Systems")
            
            setPermissions(userData.Permissions || [])
            setIsLoaded(false)
            return
        }

        //* ORIGINAL CODE - Commented for bypass
        // roleService.get().then(res => {
        //     console.log('INFO', res)
        //     if (res.name === 'AxiosError') {
        //         localStorage.removeItem("tokenMaeil")
        //         navigate('/login')
        //     }
        //     if (res.User && res.Tenant && res.RoleDetails) {
        //         sessionStorage.setItem('companies', JSON.stringify(res.Companies))
        //         localStorage.setItem("accountName", res.User.UserName)
        //         localStorage.setItem("accountCompany", res.Tenant)
        //         setPermissions(res.RoleDetails.map(roles => { return roles.Value }))
        //         setIsLoaded(false)
        //     } else {
        //         setIsLoaded(false)
        //         localStorage.removeItem("tokenMaeil")
        //         navigate('/login')
        //     }
        // })
        // eslint-disable-next-line
    }, [])

    return (
        <>
            {isLoaded ? (<LoadingBar />) : (<TabsHomePage roles={permissions} />)}
        </>
    )
}